import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    document.querySelectorAll(".copy-button").forEach(button => {
      button.addEventListener("click", () => {
        const code = button.dataset.code
        navigator.clipboard.writeText(code)
          .then(() => {
            button.textContent = "Copied!"
            setTimeout(() => {
              button.textContent = "Copy"
            }, 1500)
          })
      })
    })
  }
}
